import { Wand2, CheckCircle2, Mail, MessageCircle, FileText, Languages } from "lucide-react";
import HubLayout from "./HubLayout";

export default function Write() {
  return (
    <HubLayout
      eyebrow="Write"
      headline="Write English that"
      italic="lands."
      subhead="Paste any message — get it rewritten in the tone you actually need. Email, WhatsApp, IELTS essay. Soon: instant, ten ways at once."
      cards={[
        {
          Icon: Wand2, accent: "var(--gold-500)",
          title: "Rephrase Studio",
          lede: "Paste any message. Get it back as professional, polite, confident, fluent, IELTS-ready — ten tones at once.",
          to: "/write/rephrase",
        },
        {
          Icon: Languages, accent: "var(--sky)",
          title: "Translator",
          lede: "Translate between English, Hindi, Tamil, Bengali, and 16 more. Hear the result, then polish in Rephrase.",
          to: "/write/translate",
        },
        {
          Icon: Mail, accent: "var(--rust)",
          title: "Email assistant",
          lede: "Leave request, HR follow-up, apology to a client, salary negotiation. Drafts that arrive sounding like a person.",
          to: "/write/email",
        },
        {
          Icon: MessageCircle, accent: "var(--sky)",
          title: "WhatsApp → Professional",
          lede: "Hinglish or Tamil-English in, polished English out. The one your manager will read twice.",
          to: "/write/whatsapp",
        },
        {
          Icon: CheckCircle2, accent: "var(--sage)",
          title: "Grammar checker",
          lede: "200+ rules. Catches articles, tenses, prepositions, common Indian-English patterns. Tells you why, not just what.",
          to: "/conversation-practice",
        },
        {
          Icon: FileText, accent: "var(--ink-700)",
          title: "IELTS writing evaluator",
          lede: "Task 1 and Task 2. Band score, coherence, vocabulary range, the three sentences you should redo.",
          to: "/write/ielts",
        },
      ]}
    />
  );
}
